import React from "react";

import { Routes, Route, useLocation, useParams } from "react-router-dom";
// import CanvasComponent from "../../components/TruInk/templates/templateComponent";
import CanvasComponent from "../../src/components/TruInk/templates/templateComponent";
import NavigationBar from "./NavigationBar";
import KioskEditor from "./KioskEditor/KioskEditor";
import NotFound from "./NotFound";
import theme from "../theme";
import { ThemeProvider } from "@mui/material/styles";
import KioskPreview from "./KioskEditor/KioskPreview";


const TEMPLATE_ID_PATTERN = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

function WebMain() {
  const location = useLocation();

  const NON_CANVAS_PATHS = ["/", "/login", "/inkhub", "/truink"];
  const isCanvasPage = !NON_CANVAS_PATHS.includes(location.pathname);

  return (
    <>
      <ThemeProvider theme={theme}>
        {!isCanvasPage && <NavigationBar />}
        <div>
          <Routes>
            <Route path="/kiosk-editor" element={<KioskEditor />} />
            <Route path="/kioks-editor" element={<KioskEditor />} />
            <Route path="/kiosk-preview" element={<KioskPreview />} />
            <Route path="/inkhub" />
            <Route path="/truink" />
            <Route path="/login" />
            <Route path="/" />
            <Route
              path="/:templateId"
              element={<TemplateRoute />}
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </ThemeProvider>
    </>
  );
}

function TemplateRoute() {
  const { templateId } = useParams();
  if (!TEMPLATE_ID_PATTERN.test(templateId || "")) {
    return <NotFound />;
  }
  return <CanvasComponent />;
}

export default WebMain;
